import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonConstants } from 'src/app/shared/constants/common.constant';
import { Model } from 'src/app/shared/models/clux/model-legacy';

import { RecordsPerPageFilterService } from '../../services/records-per-page-filter.service';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-load-more',
  templateUrl: './load-more.component.html',
  styleUrls: ['./load-more.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButton, MatProgressSpinner],
})
export class LoadMoreComponent<T> implements OnChanges, OnDestroy {
  private recordsPerPageFilterService = inject(RecordsPerPageFilterService);

  @Input() public dataLoading: boolean;
  public showLoadMoreButton: boolean;
  @Input() private scrollData: Model.SearchResults<T[]>;
  @Input() private useDefaultNumberOfRecord: boolean;
  @Input() private pageSize: number;
  @Output() private action: EventEmitter<number[]> = new EventEmitter<number[]>();
  private recordsPerPage: number;
  private serviceSubscriptions = new Subscription();

  constructor() {
    this.serviceSubscriptions.add(
      this.recordsPerPageFilterService.recordsPerPage.subscribe((recordsPerPage) => {
        return (this.recordsPerPage = recordsPerPage);
      })
    );

    this.recordsPerPage = this.pageSize || CommonConstants.recordsPerPageOptions[0];
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.scrollData) {
      this.showLoadMoreButton = true;
      if (!changes.scrollData.currentValue.hasMore) {
        this.showLoadMoreButton = false;
      }
    }
  }

  public ngOnDestroy(): void {
    this.serviceSubscriptions.unsubscribe();
  }

  public onLoadMore(): void {
    if (this.scrollData.hasMore) {
      this.action.emit([this.useDefaultNumberOfRecord ? CommonConstants.loadMoreRecordsCount : this.recordsPerPage, this.scrollData.data.length]);
    }
  }
}
